export type HighlightSegment = { text: string; highlighted: boolean };

/**
 * `escaped` means the text around the tags is, so it has to be decoded for display.
 */
export type HighlightFormat = { tag: 'b' | 'strong'; escaped: boolean };

export const ASSET_SNIPPET: HighlightFormat = { tag: 'b', escaped: false };

export const COLLECTION_NAME: HighlightFormat = { tag: 'strong', escaped: true };

export const GUIDELINE_TITLE: HighlightFormat = { tag: 'strong', escaped: false };

// Exactly what Lucene's SimpleHTMLEncoder (OpenSearch/SOLR's `html` encoder) produces.
const HTML_ENTITIES: Record<string, string> = {
	'&lt;': '<',
	'&gt;': '>',
	'&amp;': '&',
	'&quot;': '"',
	'&#x27;': "'",
	'&#x2F;': '/',
};

const decodeHtmlEntities = (text: string) =>
	text.replace(/&(?:lt|gt|amp|quot|#x27|#x2F);/g, (entity) => HTML_ENTITIES[entity]);

export const parseHighlightedText = (
	value: string,
	format: HighlightFormat,
): HighlightSegment[] => {
	const openTag = `<${format.tag}>`;
	const closeTag = `</${format.tag}>`;
	const shouldDecode = format.escaped && value.includes(openTag);

	const segments: HighlightSegment[] = [];
	let highlighted = false;

	value.split(new RegExp(`(${openTag}|${closeTag})`)).forEach((part) => {
		if (part === openTag || part === closeTag) {
			highlighted = part === openTag;

			return;
		}

		if (part) {
			segments.push({ text: shouldDecode ? decodeHtmlEntities(part) : part, highlighted });
		}
	});

	return segments;
};
